import { v4 as uuidv4 } from 'uuid';
import { Div, Span, Checkbox, TextInput, CollectionPrinter } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { AddFieldBox } from "../../Components/Admin/AddFieldBox";
import { DescriptionEditor } from "../../Components/Description/DescriptionEditor";
import { GalleryItemEditor } from "../../Components/Description/Gallery/GalleryItemEditor";
import { PicsUploader } from "../../Components/Description/Gallery/PicsUploader";
import { Notification } from "../../Components/Notification";
import { DangerButton } from "../../Components/Utils/DangerButton";
import { PrimaryButton } from "../../Components/Utils/PrimaryButton";
import { FoldableSection } from "../../Components/Utils/Section";
import { BlogArticle } from "../../Models/Blog/BlogArticle";
import { GalleryItem } from "../../Models/Description/Gallery/GalleryItem";
import { BlogContentProvider } from "../../Services/Content/BlogContentProvider";
import { Heading } from "../../Components/Heading";
import { Page } from "../Product/Page";
import { Panel } from '../Product/Panel';
import { FormPrinter, FormRow } from '../Product/InputsPrinter';
import { ColumnBox } from '../Product/ColumnBox';


export class ArticleEditPage extends Page
{
    constructor(private _blog: BlogContentProvider, private articleUrl?: string)
    {
        super("Edycja artykułu", "admin-page");

        this.Content(async (body) =>
        {
            await this._blog.Load();

            const blog = this._blog.Blog;

            const newArticleId = this.articleUrl || uuidv4();
            const article = blog.Articles.Items.find(x => x.Url.value == this.articleUrl) || new BlogArticle({ Id: newArticleId, Url: newArticleId, Title: "Artykuł-" + newArticleId.slice(-8).toUpperCase() });

            this.SetTitle(article.Title.value + " - edycja");

            if (article.IsNew)
            {
                body.Append(new Heading("Tworzenie nowego artykułu", 1));
            }
            else body.Append(new Heading("Edycja artykułu #" + article.Url.value.toUpperCase(), 1));

            const uploader = new PicsUploader((images) =>
                article.Images.Add(
                    ...images.map(x => new GalleryItem({ NormalizedUrl: x.Normalized, ThumbnailUrl: x.Thumbnail, MiniUrl: x.Mini }))))
                .Hide();

            body.Append(
                new Panel("Meta", [
                    new FormPrinter([
                        new FormRow("Id", new Span(article.Id || "(puste pole id)")),
                        new FormRow("Kategoria", new TextInput(article.Category).Placeholder("Kategoria artykułu")),
                        new FormRow("Widoczny na stronie", new Checkbox(article.Visible)),
                        new FormRow("Tytuł", new TextInput(article.Title).Placeholder("Nazwa widoczna")),
                        new FormRow("Podpis", new TextInput(article.Subtitle).Placeholder("Podpis pod nazwą")),
                        new FormRow("Url", new TextInput(article.Url).Placeholder("Tekst w url (bez spacji i polskich znaków!)")),
                    ]),
                ]),

                new Panel("Zdjęcia", [
                    "Pierwsze zdjęcie to miniatura artykułu",
                    new CollectionPrinter(article.Images, x => new GalleryItemEditor(x, article.Images)),
                    new PrimaryButton("➕ Dodaj zdjęcia").OnClick(() => uploader.Show()),
                    uploader,
                ]),

                new Panel("Opis", [
                    new DescriptionEditor(article.Content),
                ]),

                new ColumnBox(
                    new PrimaryButton("Zapisz i otwórz podgląd")
                        .OnClick(async () =>
                        {
                            if (article.IsNew)
                            {
                                article.PublishDate.value = new Date();
                                blog.Articles.Add(article);
                            }
                            await this.Save();
                            window.location.hash = `blog/${article.Url.value}`;
                        }),

                    (!article.IsNew) && new DangerButton("Usuń")
                        .OnClick(async () =>
                        {
                            if (confirm("Czy na pewno chcesz usunąć ten artykuł? Możesz go też tylko ukryć."))
                            {
                                blog.Articles.Remove(article);
                                await this.Save();
                                window.location.hash = `blog`;
                            }
                            else 
                            {
                                new Notification("Anulowano usuwanie artykułu");
                            }
                        }),
                ),
            );
        });
    }

    private async Save(): Promise<void>
    {
        const result = await this._blog.SaveChanges();

        new Notification(result.IsSuccess
            ? "Zmiany zapisane!"
            : "❌ Problem z zapisaniem zmian", result.ErrorMessage || (result.ContentSize.toFixed(2) + "kb"));
    }
}
